export const layerLabelStyle = {
  fontFamily: "Arial",
  fontSize: 12,
  lineHeightMultiplier: 1.35,
  paddingX: 10,
  paddingY: 10,
  borderWidth: 2,
  borderRadius: 3,
  backgroundAlpha: 0.95,
  textColor: "#000000",
  shadow: "0 1px 3px rgb(0 0 0 / 40%)",
} as const;

export const layerLabelExportMinimums = {
  fontSize: 18,
  lineHeightMultiplier: 1.35,
  paddingX: 12,
  paddingY: 10,
  borderWidth: 2,
  minWidth: 140,
  minHeight: 46,
} as const;
